import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { ProductReveal } from './components/ProductReveal';
import { BonusSection } from './components/BonusSection';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingSection } from './components/PricingSection';
import { Testimonials } from './components/Testimonials';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { SocialProofPopup } from './components/SocialProofPopup';
import { Footer } from './components/Footer';
// Define fbq type for TypeScript
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel Code — safe initialization
    try {
      if (!window.fbq) {
        const n: any = window.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        window._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
      }
      window.fbq('init', '1492818302069438');
      window.fbq('track', 'PageView');
    } catch (e) {
      console.warn('Meta Pixel failed to initialize:', e);
    }
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-brand-gold selection:text-black" data-id="element-0">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1492818302069438&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <PainPoints data-id="element-5" />
        <ProductReveal data-id="element-6" />
        <BonusSection data-id="element-7" />
        <CountdownTimer data-id="element-8" />
        <PricingSection id="pricing" data-id="element-9" />
        <Testimonials data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <FAQSection data-id="element-12" />
        {/* Second Pricing Section as requested */}
        <PricingSection id="pricing-bottom" data-id="element-13" />
      </main>

      <Footer data-id="element-14" />
      <SocialProofPopup data-id="element-15" />
    </div>;
}